import React from 'react';
import PropTypes from 'prop-types';

export default function ProjectIcon(props) {


    let sessionProject = props.projectId ? gd.session.projects.get(props.projectId) : props.project;

    // patch to support templates
    // try check in tempaltes
    if (!sessionProject) {
        sessionProject = gd.session.templatesList.get(props.projectId);
    }

    const getColorClass = () => {
        // const { projectId, project } = this.props;
        // const sessionProject = projectId ? gd.session.projects.get(projectId) : project;
        return 'gd-c-font-'+sessionProject.color;
    };

    // if no project found in session not in templates return false
    if (!sessionProject) {
        console.warn("ProjectIconUI5: no project in session");
        return false;
    }

    const colorClass = (props.colorize)?getColorClass():false;
    let styles = {};

    return <div className={Classes("gd-ui-project-icon", sessionProject.iconClass, colorClass, props.type + "-type", props.className)} style={styles}/>;


}

ProjectIcon.propTypes = {
    project: PropTypes.object,                      // color projectIcon, systemType
    projectId: PropTypes.string,

    type: PropTypes.oneOf(['default','list', 'app-header']),

    colorize: PropTypes.bool
};

ProjectIcon.defaultProps = {
    type: "default"
};